import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useContext,
} from "react";
import axios from "axios";
import Select from "react-select";
import { useParams, Link, useNavigate } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import JsBarcode from "jsbarcode";
import { toastError, toastSuccess, toastWarn } from "../../../common/Toast";
import {
  CUSTOM_SELECT_DROPDOWN_STYLE,
  DATA_EXPORT,
  ERROR_MESSAGE,
} from "../../../common/Constant";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
//--------Material React Table------//
import { Box, Button } from "@mui/material";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import { Stack } from "react-bootstrap";
import CurrencySymbols from "../../../common/CurrencySymbol";
import { AppContext } from "../../../context/AppContext";

const ProfitandLossDetail = (props) => {
  const token = localStorage.getItem("Token");
  const loginuserid = localStorage.getItem("ID");
  const locationid = localStorage.getItem("Location");
  const { CurrencySymbol, FractionDigits, dateFormate } =
    useContext(AppContext);
  const searchParams = new URLSearchParams(window.location.search);
  let iParam = searchParams.get("custid") || 0;
  let iStartDate = searchParams.get("startdate") || "";
  let iEndDate = searchParams.get("enddate") || "";
   const navigate = useNavigate();
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const [apiCalled, setApiCalled] = useState(false);
  const [totalIncome, setTotalIncome] = useState(0);
  const [totalExpense, setTotalExpense] = useState(0);
  const [totalCostOfGoodsSold, setTotalCostOfGoodsSold] = useState(0);
  const [totalOtherIncomeExpense, setTotalOtherIncomeExpense] = useState(0);
  const [startdate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [enddate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(7);
  // const [columnOrder, setColumnOrder] = useState([]);
  // const [columnVisibility, setColumnVisibility] = useState({});

  console.log(responseData, "responseData");

  const [data, setData] = useState([]);

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  const handleDropdownChange = (event) => {
    setSelectReport(event?.value);
    if (event?.value == 1) {
      setStartDate("");
      setEndDate("");
    }
  };

  const apicall = () => {
    setLoading(true);
    setResponseData([]);
    let SDate = startdate !== "" ? startdate : iStartDate;
    let EDate = enddate !== "" ? enddate : iEndDate;
    axios
      .get(
        `${config.reportsBaseUrl}/reports/profitlossdetail?startdate=${startdate}&enddate=${enddate}&loginId=${loginuserid}&locationid=${locationid}&customerid=${iParam}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res======>", res.data.ResponseData.list);
        if (res.data.ResponseCode === "SUCCESS") {
          if (res.data.ResponseData.list.length > 0) {
            const FilterData = res.data.ResponseData.list?.map((el) => ({
              ...el,
              Amount: Number(el?.Amount),
            }));
            navigate("/profit-and-loss-detail");
            setResponseData(FilterData);
            setData(FilterData);
            setLoading(false);
          } else {
            toastWarn("No Records found!");
          }
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  if (iParam > 0 && apiCalled === false) {
    apicall();
    setApiCalled(true);
  }

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setSelectedDate(res.data.ResponseData);
        return res;
      });
  }, []);

  // to calculate the total
  const calculateTotalSum = () => {
    const validData = Array.isArray(responseData) ? responseData : []; // Default to empty array if not valid
    const sum = validData.reduce((total, report) => {
      const reportTotal = Number(report?.Total);

      if (typeof reportTotal === "number" && !isNaN(reportTotal)) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);

    setTotalSum(sum);
  };

  // to calculate the total
  const calculateTotalIncome = () => {
    if (!Array.isArray(responseData)) {
      // Handle invalid responseData by setting total income to 0 or any fallback
      setTotalIncome(0);
      return;
    }

    const sum = responseData.reduce((total, report) => {
      const reportTotal = Number(report.Amount);

      if (
        typeof reportTotal === "number" &&
        !isNaN(reportTotal) &&
        report.AccountTypeId === 1
      ) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);

    setTotalIncome(sum);
  };

  const calculateTotalCostOfGoodsSold = () => {
    if (!Array.isArray(responseData)) {
      // Handle case where responseData is not an array (could log or set the total to 0)
      setTotalCostOfGoodsSold(0);
      return;
    }

    const sum = responseData.reduce((total, report) => {
      const reportTotal = Number(report.Amount);

      if (
        typeof reportTotal === "number" &&
        !isNaN(reportTotal) &&
        report.AccountTypeId === 3
      ) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);

    setTotalCostOfGoodsSold(sum);
  };

  const calculateTotalExpense = () => {
    if (!Array.isArray(responseData)) {
      // If responseData is not an array, set total expense to 0
      setTotalExpense(0);
      return;
    }

    const sum = responseData.reduce((total, report) => {
      const reportTotal = Number(report.Amount);

      if (
        typeof reportTotal === "number" &&
        !isNaN(reportTotal) &&
        report.AccountTypeId === 4
      ) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);

    setTotalExpense(sum);
  };

  const calculateTotalOtherIncomeExpense = () => {
    if (!Array.isArray(responseData)) {
      // If responseData is not an array, set total to 0
      setTotalOtherIncomeExpense(0);
      return;
    }

    const sum = responseData.reduce((total, report) => {
      const reportTotal = Number(report.Amount);

      if (
        typeof reportTotal === "number" &&
        !isNaN(reportTotal) &&
        report.Type === "Other Income/Expense"
      ) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);

    setTotalOtherIncomeExpense(sum);
  };

  useEffect(() => {
    calculateTotalSum();
    calculateTotalCostOfGoodsSold();
    calculateTotalIncome();
    calculateTotalExpense();
    calculateTotalOtherIncomeExpense();
  }, [responseData]);

  const callback = (payload, enddate2) => {
    setStartDate(payload);
    setEndDate(enddate2);
  };

  const columns = [
    {
      header: "Date",
      accessorKey: "Date",
      size: "120",
      Cell: ({ row }) => {
        const Date = moment(row.original.Date);
        if (Date.isValid()) {
          return moment(Date).format(`${dateFormate.toUpperCase()}`);
        } else {
          return "";
        }
      },
    },
    {
      header: "Transaction Type",
      accessorKey: "TransactionType",
      size: "120",
      Cell: ({ row }) => (
        <Box
          component="span"
          sx={{
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            textDecoration: "underline",
            textUnderlineOffset: "3px",
            p: "0.3rem",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            fontWeight: "700",
          }}
          onClick={() => {
            const url =
              row.original?.TransactionType === "Payment"
                ? `/receive-payment/${row.original.TxnId}`
                : row.original?.TransactionType === "Invoice" ||
                  row.original?.TransactionType === "Credit Memo"
                ? `/sales-receipt/${row.original.TxnId}`
                : row.original?.TransactionType === "Bill" ||
                  row.original?.TransactionType === "Supplier Return" ||
                  row.original?.TransactionType === "Vendor Credit"
                ? `/receiving-receipt/${row.original.TxnId}`
                : row.original?.TransactionType === "Journal"
                ? `/journal-entry/${row.original.TxnId}`
                : row.original?.TransactionType === "Deposit"
                ? `/bank-deposit/${row.original.TxnId}`
                : row.original?.TransactionType === "Expense"
                ? `/Expense/${row.original.TxnId}`
                : "#";

            window.open(url, "_blank"); // Open in a new tab
          }}
        >
          {row.original.TransactionType}
        </Box>
      ),
    },
    {
      header: "Num",
      accessorKey: "Num",
      filterFn: "contains",
      size: "110",
    },
    {
      header: "Name",
      accessorKey: "Name",
      filterFn: "contains",
      size: "110",
    },
    {
      header: "Memo/Description",
      accessorKey: "MemoDescription",
      filterFn: "contains",
      size: "120",
    },
    {
      header: "Amount",
      accessorKey: "Amount",
      filterFn: "contains",
      size: "120",
      Cell: ({ row }) => {
        const TotalAmount = row?.original?.Amount;

        return (
          <div style={{ textAlign: "end" }}>
            {CurrencySymbols(
              Number(TotalAmount),
              { CurrencySymbol },
              FractionDigits
            )}
          </div>
        );
      },
      AggregatedCell: ({ cell, table }) => {
        const groupingColumnId = cell.row.groupingColumnId ?? "";
        const originalValue =
          cell.row.original?.[groupingColumnId] ??
          cell.row.subRows?.[0]?.original?.[groupingColumnId];

        // Retrieve the aggregated value
        const aggregatedValue = cell.getValue();

        // Check if the value is valid and format it
        const formattedValue =
          typeof aggregatedValue === "number" ? aggregatedValue : 0;

        return (
          <>
            <Box component="span" sx={{ fontWeight: "bold" }}>
              Total for {originalValue ?? "Unknown"}:
            </Box>{" "}
            <Box
              sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
            >
              {/* {formattedValue} */}
              {CurrencySymbols(
                Number(formattedValue),
                { CurrencySymbol },
                FractionDigits
              )}
            </Box>
          </>
        );
      },
      Footer: () => (
        <>
          {/* <div style={{ textAlign: "end" }}> */}
          <Stack>
            Gross Profit:{" "}
            {CurrencySymbols(
              Number(totalIncome - totalCostOfGoodsSold),
              { CurrencySymbol },
              FractionDigits
            )}
            {/* <Box color="warning.main"></Box> */}
          </Stack>
          <Stack>
            Net Income:{" "}
            {CurrencySymbols(
              Number(
                totalIncome +
                  totalExpense +
                  totalCostOfGoodsSold -
                  totalOtherIncomeExpense
              ),
              { CurrencySymbol },
              FractionDigits
            )}
            {/* <Box color="warning.main"></Box> */}
          </Stack>
          {/* </div> */}
        </>
      ),
    },
    {
      header: "Balance",
      accessorKey: "Balance",
      filterFn: "contains",
      size: "120",
      Cell: ({ row }) => {
        return (
          <div style={{ textAlign: "end" }}>
            {CurrencySymbols(
              Number(row?.original?.Balance),
              { CurrencySymbol },
              FractionDigits
            )}
          </div>
        );
      },
    },
    {
      header: "Create Date",
      accessorKey: "CreateDate",
      filterFn: "contains",
      size: "100",
      Cell: ({ row }) => {
        const CreatedDate = row?.original?.CreatedDate;
        if (
          CreatedDate === "0000-00-00" ||
          CreatedDate === "" ||
          CreatedDate === null
        ) {
          return "";
        }
        return moment(CreatedDate).format(
          `${dateFormate.toUpperCase()} hh:mm A`
        );
      },
    },
    {
      header: "Created By",
      accessorKey: "CreatedBy",
      filterFn: "contains",
      size: "100",
    },
    {
      header: "Last Modified",
      accessorKey: "LastModified",
      filterFn: "contains",
      size: "100",
      Cell: ({ row }) => {
        const ModifiedDate = row?.original?.LastModifiedDate;
        if (
          ModifiedDate === "0000-00-00" ||
          ModifiedDate === "" ||
          ModifiedDate === null
        ) {
          return "";
        }
        return moment(ModifiedDate).format(
          `${dateFormate.toUpperCase()} hh:mm A`
        );
      },
    },
    {
      header: "Last Modified By",
      accessorKey: "LastModifiedBy",
      filterFn: "contains",
      size: "100",
    },
    {
      header: "Debit",
      accessorKey: "Debit",
      filterFn: "contains",
      size: "100",
      Cell: ({ row }) => {
        return (
          <div style={{ textAlign: "end" }}>
            {CurrencySymbols(
              Number(row?.original?.Debit),
              { CurrencySymbol },
              FractionDigits
            )}
          </div>
        );
      },
    },
    {
      header: "Credit",
      accessorKey: "Credit",
      filterFn: "contains",
      size: "100",
      Cell: ({ row }) => {
        return (
          <div style={{ textAlign: "end" }}>
            {CurrencySymbols(
              Number(row?.original?.Credit),
              { CurrencySymbol },
              FractionDigits
            )}
          </div>
        );
      },
    },
    {
      header: "Payment Method",
      accessorKey: "PaymentMethod",
      filterFn: "contains",
      size: "120",
    },
    {
      header: "Account Name",
      accessorKey: "AccountName",
      filterFn: "contains",
      size: "120",
    },
    {
      header: "Account Type",
      accessorKey: "AccountType",
      filterFn: "contains",
      size: "120",
    },
    {
      header: "Type",
      accessorKey: "Type",
      filterFn: "contains",
      size: "120",
    },
  ];

  // const onGridReady = useCallback((params) => {
  //   setLoading(true);

  //   axios
  //     .get(
  //       `${
  //         config.reportsBaseUrl
  //       }/reports/profitlossdetail?startdate=${""}&enddate=${""}`,
  //       {
  //         headers: {
  //           "Content-Type": "application/json;charset=UTF-8",
  //           "Access-Control-Allow-Origin": "*",
  //           Authorization: token,
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       console.log("res======>", res);
  //       console.log(res.data.ResponseData);
  //       if (res.data.ResponseCode === "SUCCESS") {
  //         setResponseData(res.data.ResponseData);
  //         setData(res.data.ResponseData);
  //         // setOpenBalance(res.data.ResponseData.OpenBalance);
  //       }
  //       data.Total = parseInt(data.Total, 10);
  //       data.Balance = parseInt(data.Balance, 10); // Convert to integer

  //       console.log("data.OpenBalance", data.OpenBalance);
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       setLoading(false);
  //     });
  // }, []);

  // useEffect(() => {
  //   onGridReady();
  // }, [onGridReady]);

  // const totalFooterRow = {
  //   Product: "Net Income",
  //   Total: totalSum,
  //   // OpenBalance: totalbalance,
  // };

  // const totalPages = Math.ceil(responseData.length / ITEMS_PER_PAGE);

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3>Open Purchase Order List</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Profit and Loss Detail
                </li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-3">
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                Report period
              </label>
              <div className="row">
                <div className="col-md-12 z-3">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={reportdropdown}
                    value={reportdropdown.find((e) => e.value === selectReport)}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    // isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    //  value={selectedDate}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            {selectReport !== 1 && (
              <div className="col-sm-3">
                {/* <div className="row"> */}
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
                {/* </div> */}
              </div>
            )}
            <div className="col-sm-2 align-self-sm-end">
              <button
                type="submit"
                className="btn btn-primary"
                // style={{ marginLeft: "auto" }}
                onClick={() => apicall()}
              >
                Run Report
              </button>
            </div>
            {/* <div
              className="cursor-pointer col-md-3 d-flex justify-content-end mt-5"
              onClick={() =>
                handleSaveColumnOrder(
                  loginuserid,
                  "ProfitAndLossReport",
                  columnOrder,
                  token,
                  columnVisibility
                )
              }
              title="Lock Your Sequence"
            >
              <i class="fa fa-lock columnsLock fs-4"></i>
            </div> */}
          </div>

          {/* Receipt */}
          {responseData.length > 0 && (
            <div className="card mt-3">
              <div className="card-body">
                <div className="container">
                  <div className="col-md-12 text-center" id="header">
                    <h6 className="p">SonarPos</h6>
                    <p className="fw-bold p-regular">Profit and Loss Detail</p>
                    <div className="row mb-2">
                      {/* <h6> Date: {new Date().toLocaleDateString()}</h6> */}
                      <p>
                        Date:{" "}
                        {startdate === "" && enddate === ""
                          ? "All Data"
                          : moment(startdate).format(
                              `${dateFormate.toUpperCase()}`
                            ) +
                            " - " +
                            moment(enddate).format(
                              `${dateFormate.toUpperCase()}`
                            )}
                      </p>
                    </div>
                  </div>
                </div>
                <hr />

                <div>
                  <CommonMatrialReactTable
                    MainHeading="Sonar POS"
                    ReportHeading="Profit And Loss Report"
                    columns={columns}
                    data={responseData}
                    startdate={startdate}
                    enddate={enddate}
                    columnGrouping={["Type", "AccountType", "AccountName"]}
                    enableExpandAll={true}
                    enableExpanding={true}
                    expanded={true}
                    enableRowSelection={false}
                    columnsVisibility={{
                      CreateDate: false,
                      CreatedBy: false,
                      LastModified: false,
                      LastModifiedBy: false,
                      Debit: false,
                      Credit: false,
                      PaymentMethod: false,
                    }}
                    // setColumnOrder={setColumnOrder}
                    // setColumnVisibility={setColumnVisibility}
                    // state={{
                    //   columnOrder,
                    //   columnVisibility,
                    // }}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ProfitandLossDetail;
